import { CircularDependencyFreeStore } from '../CircularDependencyFreeStore'
import { PageStore } from './store'

const pageStore = new PageStore()

CircularDependencyFreeStore.pageStore = pageStore

export { pageStore, pageStore as default }
